import { BiddingConsoleLeftSection } from './components/BiddingConsoleLeftSection/BiddingConsoleLeftSection';
import { BiddingConsoleMiddleSection } from './components/BiddingConsoleMiddleSection/BiddingConsoleMiddleSection';
import { BiddingConsoleRightSection } from './components/BiddingConsoleRightSection/BiddingConsoleRightSection';
import { CurrencyCode } from '@liveauctioneers/hammer-ui-liveauctioneers/lotDetail';
import { getLiveCatalogCurrentItemId } from '@/redux/modules/console';
import { useAppSelector } from '@/redux/hooks';
import { useState } from 'react';

type Props = {
    catalogId: number;
};

export const DesktopBiddingConsoleExperiment = ({ catalogId }: Props) => {
    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));

    const [selectedCurrency, setSelectedCurrency] = useState<CurrencyCode>();

    return (
        <div className="h-screen w-full bg-background-subdued">
            <div className="mx-auto grid grid-cols-[minmax(250px,402px)_minmax(400px,100%)_minmax(250px,402px)] gap-md p-md">
                <BiddingConsoleLeftSection
                    catalogId={catalogId}
                    selectedCurrency={selectedCurrency}
                    setSelectedCurrency={setSelectedCurrency}
                />
                <BiddingConsoleMiddleSection
                    itemId={itemId}
                    selectedCurrency={selectedCurrency}
                />
                <BiddingConsoleRightSection catalogId={catalogId} />
            </div>
        </div>
    );
};
